import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Modal, Spin, Form, Select } from 'antd';
import NavBar from '../Common/NavBar/NavBar';
import SideBar from '../Common/SideBar/SideBar';
import Grid from '../Common/Grid/Grid';
import {
  getAllUsers,
  getUserSurvey,
  getUserPartPoint,
  getPartPointSelectList,
  addUserPartPoint
} from '../../Network/Network';
import { exportToExcel, searchFunction } from '../../Helpers/helpers';
import { toastError, toastSuccess } from '../../Helpers/toasters';
import moment from 'moment';

function UsersPage() {
  const [tableLoading, setTableLoading] = useState(true);
  const [dataSource, updateDataSource] = useState([]);
  const [allDataSource, updateAllDataSource] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [rerender, updateRerender] = useState(false);
  const [searchValue, updateSearchValue] = useState('');
  let [dateFrom, setDateFrom] = useState(null);
  let [dateTo, setDateTo] = useState(null);
  const [partsModalOpen, setPartsModalOpen] = useState(false);
  const [partsLoading, setPartsLoading] = useState(false);
  const [userParts, setUserParts] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [addPartModalOpen, setAddPartModalOpen] = useState(false);
  const [partsSelectList, setPartsSelectList] = useState([]);
  const [partsSelectLoading, setPartsSelectLoading] = useState(false);
  const [addPartSaving, setAddPartSaving] = useState(false);
  const [addPartForm] = Form.useForm();
  const Navigate = useNavigate();

  useEffect(() => {
    // setTableLoading(true);
    const searchColumns = ['name', 'mobile', 'groupName'];
    const searchedDataSource = searchFunction(allDataSource, searchValue, searchColumns);
    updateDataSource(searchedDataSource);
    setFilteredDataSource(searchedDataSource);
    // setTableLoading(false);
    // eslint-disable-next-line
  }, [searchValue]);

  useEffect(() => {
    getAllUsersData();
    //eslint-disable-next-line
  }, [rerender, dateFrom, dateTo]);

  const getAllUsersData = () => {
    getAllUsers(
      (success) => {
        if (success?.isSuccess) {
          updateDataSource(success.data);
          updateAllDataSource(success.data);
          setFilteredDataSource(success.data);
          setTableLoading(false);
        }
      },
      (fail) => {},
      { from: dateFrom, to: dateTo }
    );
  };

  const getUserSurveyData = (userId) => {
    let data = {
      userId
    };
    getUserSurvey(data, (success) => {
      Navigate('/survey', {
        state: {
          data: success.data,
          userId
        }
      });
    });
  };

  const getUserPartsData = (record) => {
    setSelectedUserName(record.name || '');
    setPartsLoading(true);
    setPartsModalOpen(true);
    getUserPartPoint(
      { userId: record._id },
      (success) => {
        if (success?.isSuccess) {
          setUserParts(success.data || []);
        } else {
          toastError('فشل تحميل الأجزاء');
          setUserParts([]);
        }
        setPartsLoading(false);
      },
      () => {
        toastError('حدث خطأ أثناء تحميل الأجزاء');
        setUserParts([]);
        setPartsLoading(false);
      }
    );
  };

  const openAddPartModal = (record) => {
    setSelectedUserName(record.name || '');
    setSelectedUserId(record._id);
    setAddPartModalOpen(true);
    addPartForm.resetFields();
    setPartsSelectLoading(true);
    getPartPointSelectList(
      (success) => {
        if (success?.isSuccess) {
          setPartsSelectList(success.data || []);
        } else {
          toastError('فشل تحميل قائمة الأجزاء');
          setPartsSelectList([]);
        }
        setPartsSelectLoading(false);
      },
      () => {
        toastError('حدث خطأ أثناء تحميل قائمة الأجزاء');
        setPartsSelectList([]);
        setPartsSelectLoading(false);
      }
    );
  };

  const handleAddPart = (values) => {
    setAddPartSaving(true);
    addUserPartPoint(
      {
        partId: values.partId,
        userId: selectedUserId
      },
      (res) => {
        setAddPartSaving(false);
        if (res?.isSuccess) {
          toastSuccess(res?.message || 'تمت إضافة الجزء بنجاح');
          setAddPartModalOpen(false);
          addPartForm.resetFields();
          setSelectedUserId(null);
        } else {
          toastError(res?.message || 'فشل في إضافة الجزء');
        }
      },
      () => {
        setAddPartSaving(false);
        toastError('حدث خطأ أثناء إضافة الجزء');
      }
    );
  };

  const columns = [
    {
      title: 'الاسم',
      key: 'name',
      dataIndex: 'name'
    },

    {
      title: 'رقم الهاتف',
      key: 'mobile',
      dataIndex: 'mobile'
    },
    {
      title: ' تاريخ الالتحاق',
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: (_, record) => {
        return (
          <span dir="ltr">{moment(record?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
        );
      }
    },
    {
      title: 'المجموعة',
      key: 'groupName',
      dataIndex: 'groupName'
    },
    {
      title: 'الإجراءات',
      key: 'actions',
      width: 150,
      render: (_data, record) => {
        return (
          <div className="d-flex flex-column justify-content gap-1">
            <Button
              variant="primary"
              onClick={() => {
                getUserSurveyData(record._id);
              }}
            >
              الاستبيان
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                getUserPartsData(record);
              }}
            >
              الأجزاء
            </Button>
            <Button
              variant="success"
              onClick={() => {
                openAddPartModal(record);
              }}
            >
              اضافة جزء
            </Button>
          </div>
        );
      }
    }
  ];

  function changeDate(date) {
    if (date) {
      setDateFrom(date[0]);
      setDateTo(date[1]);
    } else {
      setDateFrom(null);
      setDateTo(null);
    }
  }
  const handleTableChange = (pagination, filters, sorter, extra) => {
    setFilteredDataSource(extra?.currentDataSource);
    updateDataSource(extra?.currentDataSource);
  };
  const handleExportToExcel = () => {
    let filteredData = [];
    filteredDataSource.map((student) =>
      filteredData.push({
        Name: `${student?.firstName} ${student?.lastName}`,
        Phone: student?.mobile,
        'Group Name': student?.groupName,
        'Joining Date': moment(student?.createdAt).format('YYYY-MM-DD HH:mm:ss')
      })
    );
    const data = filteredData;
    exportToExcel(data);
  };
  return (
    <div className="d-flex">
      <SideBar parent={'users'} />
      <div className="flex-1 section">
        <NavBar
          getSearchedValue={(value) => {
            updateSearchValue(value);
          }}
        />
        <Grid
          mainTitle={'الطلاب'}
          subTitle={'كل الطلاب'}
          columns={columns}
          dataSource={dataSource}
          loading={tableLoading}
          rowKey={'_id'}
          exportMe={true}
          options={true}
          searchFromTo={true}
          exportToExcel={handleExportToExcel}
          changeDate={changeDate}
          onChange={handleTableChange}
          // search={Search}
          emptyTableText={{
            emptyText: 'لا يوجد طلاب'
          }}
        />

        <Modal
          title={
            <div style={{ paddingRight: 32, fontWeight: 'bold', direction: 'rtl' }}>
              أجزاء {selectedUserName}
            </div>
          }
          visible={partsModalOpen}
          onCancel={() => {
            setPartsModalOpen(false);
            setUserParts([]);
          }}
          footer={null}
          destroyOnClose
        >
          <Spin spinning={partsLoading}>
            {userParts.length === 0 && !partsLoading ? (
              <p style={{ textAlign: 'center', margin: 0 }}>لا توجد أجزاء</p>
            ) : (
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  direction: 'rtl',
                  textAlign: 'right'
                }}
              >
                {userParts.map((part) => (
                  <li
                    key={part._id}
                    style={{
                      padding: '12px 0',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                      {part.partName}
                    </div>
                    <div>النقاط: {part.point}</div>
                    <div>تم الاستبدال: {part.isRedeemed ? 'نعم' : 'لا'}</div>
                  </li>
                ))}
              </ul>
            )}
          </Spin>
        </Modal>

        <Modal
          title={
            <div style={{ paddingRight: 32, fontWeight: 'bold', direction: 'rtl' }}>
              اضافة جزء لـ {selectedUserName}
            </div>
          }
          visible={addPartModalOpen}
          onCancel={() => {
            setAddPartModalOpen(false);
            addPartForm.resetFields();
            setSelectedUserId(null);
          }}
          footer={null}
          destroyOnClose
        >
          <Form
            form={addPartForm}
            layout="vertical"
            onFinish={handleAddPart}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name="partId"
              label="الجزء"
              rules={[{ required: true, message: 'يرجى اختيار الجزء' }]}
            >
              <Select
                placeholder="اختر الجزء"
                loading={partsSelectLoading}
                showSearch
                optionFilterProp="children"
                allowClear
              >
                {partsSelectList.map((part) => (
                  <Select.Option key={part._id} value={part._id}>
                    {part.nameAr || part.partName || part.nameEn || part.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Button
              variant="primary"
              type="submit"
              disabled={addPartSaving}
              style={{ width: '100%' }}
            >
              {addPartSaving ? 'جاري الحفظ...' : 'اضافة'}
            </Button>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default UsersPage;
